import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../components/global/modal/withModal';
import PurchasingOptions from './PurchasingOptions';

export const MEMBERSHIPS_PURCHASING_OPTIONS_MODAL =
  'MEMBERSHIPS_PURCHASING_OPTIONS_MODAL';

const propTypes = {
  actionProps: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string,
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
    isEntitled: PropTypes.bool,
  }),
};

const PurchasingOptionsModal = ({
  actionProps: { photo, album, isEntitled } = {},
  onRequestClose,
  ...props
}) => {
  return (
    <PurchasingOptions
      photo={photo}
      album={album}
      isPhotoEntitled={isEntitled}
      onClose={onRequestClose}
      {...props}
    />
  );
};

PurchasingOptionsModal.propTypes = propTypes;

export default withModal(PurchasingOptionsModal, {
  name: MEMBERSHIPS_PURCHASING_OPTIONS_MODAL,
  dismissible: false,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'memberships-purchasing-options-modal modal-contained',
});
